module.exports = __webpack_public_path__ + "static/media/arrow-circle-icon.f57d8159.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/arrow-circle-icon.svg
// module id = 1091
// module chunks = 2